/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as RootLayoutRouteImport } from './../routes/_rootLayout'
import { Route as RootLayoutIndexRouteImport } from './../routes/_rootLayout/index'
import { Route as RootLayoutVenuesRouteImport } from './../routes/_rootLayout/venues'
import { Route as RootLayoutTasksRouteImport } from './../routes/_rootLayout/tasks'
import { Route as RootLayoutSystemRouteImport } from './../routes/_rootLayout/system'
import { Route as RootLayoutReportsRouteImport } from './../routes/_rootLayout/reports'
import { Route as RootLayoutProfileRouteImport } from './../routes/_rootLayout/profile'
import { Route as RootLayoutPersonsRouteImport } from './../routes/_rootLayout/persons'
import { Route as RootLayoutMailinglistsRouteImport } from './../routes/_rootLayout/mailinglists'
import { Route as RootLayoutLoginRouteImport } from './../routes/_rootLayout/login'
import { Route as RootLayoutImpressumRouteImport } from './../routes/_rootLayout/impressum'
import { Route as RootLayoutFinanceRouteImport } from './../routes/_rootLayout/finance'
import { Route as RootLayoutDocumentsRouteImport } from './../routes/_rootLayout/documents'
import { Route as RootLayoutDashboardRouteImport } from './../routes/_rootLayout/dashboard'
import { Route as RootLayoutCompaniesRouteImport } from './../routes/_rootLayout/companies'
import { Route as RootLayoutArtistsRouteImport } from './../routes/_rootLayout/artists'
import { Route as RootLayoutVenuesIndexRouteImport } from './../routes/_rootLayout/venues/index'
import { Route as RootLayoutPersonsIndexRouteImport } from './../routes/_rootLayout/persons/index'
import { Route as RootLayoutFinanceIndexRouteImport } from './../routes/_rootLayout/finance/index'
import { Route as RootLayoutDocumentsIndexRouteImport } from './../routes/_rootLayout/documents/index'
import { Route as RootLayoutCompaniesIndexRouteImport } from './../routes/_rootLayout/companies/index'
import { Route as RootLayoutArtistsIndexRouteImport } from './../routes/_rootLayout/artists/index'
import { Route as RootLayoutVenuesIdRouteImport } from './../routes/_rootLayout/venues/$id'
import { Route as RootLayoutProjectsTouringRouteImport } from './../routes/_rootLayout/projects/touring'
import { Route as RootLayoutProjectsSalesRouteImport } from './../routes/_rootLayout/projects/sales'
import { Route as RootLayoutProjectsFestivalsRouteImport } from './../routes/_rootLayout/projects/festivals'
import { Route as RootLayoutPersonsIdRouteImport } from './../routes/_rootLayout/persons/$id'
import { Route as RootLayoutFinanceOverviewRouteImport } from './../routes/_rootLayout/finance/overview'
import { Route as RootLayoutFinanceDepositsRouteImport } from './../routes/_rootLayout/finance/deposits'
import { Route as RootLayoutCompaniesIdRouteImport } from './../routes/_rootLayout/companies/$id'
import { Route as RootLayoutArtistsIdRouteImport } from './../routes/_rootLayout/artists/$id'
import { Route as RootLayoutVenuesIdShowsRouteImport } from './../routes/_rootLayout/venues/$id.shows'
import { Route as RootLayoutVenuesIdReportsRouteImport } from './../routes/_rootLayout/venues/$id.reports'
import { Route as RootLayoutVenuesIdRentalRouteImport } from './../routes/_rootLayout/venues/$id.rental'
import { Route as RootLayoutVenuesIdOverviewRouteImport } from './../routes/_rootLayout/venues/$id.overview'
import { Route as RootLayoutVenuesIdHoldsRouteImport } from './../routes/_rootLayout/venues/$id.holds'
import { Route as RootLayoutVenuesIdGeneralRouteImport } from './../routes/_rootLayout/venues/$id.general'
import { Route as RootLayoutVenuesIdFilesRouteImport } from './../routes/_rootLayout/venues/$id.files'
import { Route as RootLayoutProjectsTouringIdRouteImport } from './../routes/_rootLayout/projects/touring.$id'
import { Route as RootLayoutPersonsIdTourrepRouteImport } from './../routes/_rootLayout/persons/$id.tourrep'
import { Route as RootLayoutPersonsIdSettlementsRouteImport } from './../routes/_rootLayout/persons/$id.settlements'
import { Route as RootLayoutPersonsIdReportsRouteImport } from './../routes/_rootLayout/persons/$id.reports'
import { Route as RootLayoutPersonsIdGeneralRouteImport } from './../routes/_rootLayout/persons/$id.general'
import { Route as RootLayoutCompaniesIdVenuesRouteImport } from './../routes/_rootLayout/companies/$id.venues'
import { Route as RootLayoutCompaniesIdShowsRouteImport } from './../routes/_rootLayout/companies/$id.shows'
import { Route as RootLayoutCompaniesIdHoldsRouteImport } from './../routes/_rootLayout/companies/$id.holds'
import { Route as RootLayoutCompaniesIdGeneralRouteImport } from './../routes/_rootLayout/companies/$id.general'
import { Route as RootLayoutCompaniesIdFinanceRouteImport } from './../routes/_rootLayout/companies/$id.finance'
import { Route as RootLayoutCompaniesIdEmployeesRouteImport } from './../routes/_rootLayout/companies/$id.employees'
import { Route as RootLayoutCompaniesIdArtistsRouteImport } from './../routes/_rootLayout/companies/$id.artists'
import { Route as RootLayoutArtistsIdShowsRouteImport } from './../routes/_rootLayout/artists/$id.shows'
import { Route as RootLayoutArtistsIdGeneralRouteImport } from './../routes/_rootLayout/artists/$id.general'
import { Route as RootLayoutArtistsIdFinanceRouteImport } from './../routes/_rootLayout/artists/$id.finance'
import { Route as RootLayoutVenuesIdRentalVersionRouteImport } from './../routes/_rootLayout/venues/$id.rental.$version'
import { Route as RootLayoutVenuesIdOverviewVersionRouteImport } from './../routes/_rootLayout/venues/$id.overview.$version'

const RootLayoutRoute = RootLayoutRouteImport.update({
  id: '/_rootLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const RootLayoutIndexRoute = RootLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutVenuesRoute = RootLayoutVenuesRouteImport.update({
  id: '/venues',
  path: '/venues',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutTasksRoute = RootLayoutTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutSystemRoute = RootLayoutSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutReportsRoute = RootLayoutReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutProfileRoute = RootLayoutProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutPersonsRoute = RootLayoutPersonsRouteImport.update({
  id: '/persons',
  path: '/persons',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutMailinglistsRoute = RootLayoutMailinglistsRouteImport.update({
  id: '/mailinglists',
  path: '/mailinglists',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutLoginRoute = RootLayoutLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutImpressumRoute = RootLayoutImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutFinanceRoute = RootLayoutFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutDocumentsRoute = RootLayoutDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutDashboardRoute = RootLayoutDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutCompaniesRoute = RootLayoutCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutArtistsRoute = RootLayoutArtistsRouteImport.update({
  id: '/artists',
  path: '/artists',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutVenuesIndexRoute = RootLayoutVenuesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootLayoutVenuesRoute,
} as any)
const RootLayoutPersonsIndexRoute = RootLayoutPersonsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootLayoutPersonsRoute,
} as any)
const RootLayoutFinanceIndexRoute = RootLayoutFinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootLayoutFinanceRoute,
} as any)
const RootLayoutDocumentsIndexRoute =
  RootLayoutDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RootLayoutDocumentsRoute,
  } as any)
const RootLayoutCompaniesIndexRoute =
  RootLayoutCompaniesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RootLayoutCompaniesRoute,
  } as any)
const RootLayoutArtistsIndexRoute = RootLayoutArtistsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RootLayoutArtistsRoute,
} as any)
const RootLayoutVenuesIdRoute = RootLayoutVenuesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => RootLayoutVenuesRoute,
} as any)
const RootLayoutProjectsTouringRoute =
  RootLayoutProjectsTouringRouteImport.update({
    id: '/projects/touring',
    path: '/projects/touring',
    getParentRoute: () => RootLayoutRoute,
  } as any)
const RootLayoutProjectsSalesRoute = RootLayoutProjectsSalesRouteImport.update({
  id: '/projects/sales',
  path: '/projects/sales',
  getParentRoute: () => RootLayoutRoute,
} as any)
const RootLayoutProjectsFestivalsRoute =
  RootLayoutProjectsFestivalsRouteImport.update({
    id: '/projects/festivals',
    path: '/projects/festivals',
    getParentRoute: () => RootLayoutRoute,
  } as any)
const RootLayoutPersonsIdRoute = RootLayoutPersonsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => RootLayoutPersonsRoute,
} as any)
const RootLayoutFinanceOverviewRoute =
  RootLayoutFinanceOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => RootLayoutFinanceRoute,
  } as any)
const RootLayoutFinanceDepositsRoute =
  RootLayoutFinanceDepositsRouteImport.update({
    id: '/deposits',
    path: '/deposits',
    getParentRoute: () => RootLayoutFinanceRoute,
  } as any)
const RootLayoutCompaniesIdRoute = RootLayoutCompaniesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => RootLayoutCompaniesRoute,
} as any)
const RootLayoutArtistsIdRoute = RootLayoutArtistsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => RootLayoutArtistsRoute,
} as any)
const RootLayoutVenuesIdShowsRoute = RootLayoutVenuesIdShowsRouteImport.update({
  id: '/shows',
  path: '/shows',
  getParentRoute: () => RootLayoutVenuesIdRoute,
} as any)
const RootLayoutVenuesIdReportsRoute =
  RootLayoutVenuesIdReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => RootLayoutVenuesIdRoute,
  } as any)
const RootLayoutVenuesIdRentalRoute =
  RootLayoutVenuesIdRentalRouteImport.update({
    id: '/rental',
    path: '/rental',
    getParentRoute: () => RootLayoutVenuesIdRoute,
  } as any)
const RootLayoutVenuesIdOverviewRoute =
  RootLayoutVenuesIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => RootLayoutVenuesIdRoute,
  } as any)
const RootLayoutVenuesIdHoldsRoute = RootLayoutVenuesIdHoldsRouteImport.update({
  id: '/holds',
  path: '/holds',
  getParentRoute: () => RootLayoutVenuesIdRoute,
} as any)
const RootLayoutVenuesIdGeneralRoute =
  RootLayoutVenuesIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => RootLayoutVenuesIdRoute,
  } as any)
const RootLayoutVenuesIdFilesRoute = RootLayoutVenuesIdFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => RootLayoutVenuesIdRoute,
} as any)
const RootLayoutProjectsTouringIdRoute =
  RootLayoutProjectsTouringIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => RootLayoutProjectsTouringRoute,
  } as any)
const RootLayoutPersonsIdTourrepRoute =
  RootLayoutPersonsIdTourrepRouteImport.update({
    id: '/tourrep',
    path: '/tourrep',
    getParentRoute: () => RootLayoutPersonsIdRoute,
  } as any)
const RootLayoutPersonsIdSettlementsRoute =
  RootLayoutPersonsIdSettlementsRouteImport.update({
    id: '/settlements',
    path: '/settlements',
    getParentRoute: () => RootLayoutPersonsIdRoute,
  } as any)
const RootLayoutPersonsIdReportsRoute =
  RootLayoutPersonsIdReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => RootLayoutPersonsIdRoute,
  } as any)
const RootLayoutPersonsIdGeneralRoute =
  RootLayoutPersonsIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => RootLayoutPersonsIdRoute,
  } as any)
const RootLayoutCompaniesIdVenuesRoute =
  RootLayoutCompaniesIdVenuesRouteImport.update({
    id: '/venues',
    path: '/venues',
    getParentRoute: () => RootLayoutCompaniesIdRoute,
  } as any)
const RootLayoutCompaniesIdShowsRoute =
  RootLayoutCompaniesIdShowsRouteImport.update({
    id: '/shows',
    path: '/shows',
    getParentRoute: () => RootLayoutCompaniesIdRoute,
  } as any)
const RootLayoutCompaniesIdHoldsRoute =
  RootLayoutCompaniesIdHoldsRouteImport.update({
    id: '/holds',
    path: '/holds',
    getParentRoute: () => RootLayoutCompaniesIdRoute,
  } as any)
const RootLayoutCompaniesIdGeneralRoute =
  RootLayoutCompaniesIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => RootLayoutCompaniesIdRoute,
  } as any)
const RootLayoutCompaniesIdFinanceRoute =
  RootLayoutCompaniesIdFinanceRouteImport.update({
    id: '/finance',
    path: '/finance',
    getParentRoute: () => RootLayoutCompaniesIdRoute,
  } as any)
const RootLayoutCompaniesIdEmployeesRoute =
  RootLayoutCompaniesIdEmployeesRouteImport.update({
    id: '/employees',
    path: '/employees',
    getParentRoute: () => RootLayoutCompaniesIdRoute,
  } as any)
const RootLayoutCompaniesIdArtistsRoute =
  RootLayoutCompaniesIdArtistsRouteImport.update({
    id: '/artists',
    path: '/artists',
    getParentRoute: () => RootLayoutCompaniesIdRoute,
  } as any)
const RootLayoutArtistsIdShowsRoute =
  RootLayoutArtistsIdShowsRouteImport.update({
    id: '/shows',
    path: '/shows',
    getParentRoute: () => RootLayoutArtistsIdRoute,
  } as any)
const RootLayoutArtistsIdGeneralRoute =
  RootLayoutArtistsIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => RootLayoutArtistsIdRoute,
  } as any)
const RootLayoutArtistsIdFinanceRoute =
  RootLayoutArtistsIdFinanceRouteImport.update({
    id: '/finance',
    path: '/finance',
    getParentRoute: () => RootLayoutArtistsIdRoute,
  } as any)
const RootLayoutVenuesIdRentalVersionRoute =
  RootLayoutVenuesIdRentalVersionRouteImport.update({
    id: '/$version',
    path: '/$version',
    getParentRoute: () => RootLayoutVenuesIdRentalRoute,
  } as any)
const RootLayoutVenuesIdOverviewVersionRoute =
  RootLayoutVenuesIdOverviewVersionRouteImport.update({
    id: '/$version',
    path: '/$version',
    getParentRoute: () => RootLayoutVenuesIdOverviewRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof RootLayoutIndexRoute
  '/artists': typeof RootLayoutArtistsRouteWithChildren
  '/companies': typeof RootLayoutCompaniesRouteWithChildren
  '/dashboard': typeof RootLayoutDashboardRoute
  '/documents': typeof RootLayoutDocumentsRouteWithChildren
  '/finance': typeof RootLayoutFinanceRouteWithChildren
  '/impressum': typeof RootLayoutImpressumRoute
  '/login': typeof RootLayoutLoginRoute
  '/mailinglists': typeof RootLayoutMailinglistsRoute
  '/persons': typeof RootLayoutPersonsRouteWithChildren
  '/profile': typeof RootLayoutProfileRoute
  '/reports': typeof RootLayoutReportsRoute
  '/system': typeof RootLayoutSystemRoute
  '/tasks': typeof RootLayoutTasksRoute
  '/venues': typeof RootLayoutVenuesRouteWithChildren
  '/artists/$id': typeof RootLayoutArtistsIdRouteWithChildren
  '/companies/$id': typeof RootLayoutCompaniesIdRouteWithChildren
  '/finance/deposits': typeof RootLayoutFinanceDepositsRoute
  '/finance/overview': typeof RootLayoutFinanceOverviewRoute
  '/persons/$id': typeof RootLayoutPersonsIdRouteWithChildren
  '/projects/festivals': typeof RootLayoutProjectsFestivalsRoute
  '/projects/sales': typeof RootLayoutProjectsSalesRoute
  '/projects/touring': typeof RootLayoutProjectsTouringRouteWithChildren
  '/venues/$id': typeof RootLayoutVenuesIdRouteWithChildren
  '/artists/': typeof RootLayoutArtistsIndexRoute
  '/companies/': typeof RootLayoutCompaniesIndexRoute
  '/documents/': typeof RootLayoutDocumentsIndexRoute
  '/finance/': typeof RootLayoutFinanceIndexRoute
  '/persons/': typeof RootLayoutPersonsIndexRoute
  '/venues/': typeof RootLayoutVenuesIndexRoute
  '/artists/$id/finance': typeof RootLayoutArtistsIdFinanceRoute
  '/artists/$id/general': typeof RootLayoutArtistsIdGeneralRoute
  '/artists/$id/shows': typeof RootLayoutArtistsIdShowsRoute
  '/companies/$id/artists': typeof RootLayoutCompaniesIdArtistsRoute
  '/companies/$id/employees': typeof RootLayoutCompaniesIdEmployeesRoute
  '/companies/$id/finance': typeof RootLayoutCompaniesIdFinanceRoute
  '/companies/$id/general': typeof RootLayoutCompaniesIdGeneralRoute
  '/companies/$id/holds': typeof RootLayoutCompaniesIdHoldsRoute
  '/companies/$id/shows': typeof RootLayoutCompaniesIdShowsRoute
  '/companies/$id/venues': typeof RootLayoutCompaniesIdVenuesRoute
  '/persons/$id/general': typeof RootLayoutPersonsIdGeneralRoute
  '/persons/$id/reports': typeof RootLayoutPersonsIdReportsRoute
  '/persons/$id/settlements': typeof RootLayoutPersonsIdSettlementsRoute
  '/persons/$id/tourrep': typeof RootLayoutPersonsIdTourrepRoute
  '/projects/touring/$id': typeof RootLayoutProjectsTouringIdRoute
  '/venues/$id/files': typeof RootLayoutVenuesIdFilesRoute
  '/venues/$id/general': typeof RootLayoutVenuesIdGeneralRoute
  '/venues/$id/holds': typeof RootLayoutVenuesIdHoldsRoute
  '/venues/$id/overview': typeof RootLayoutVenuesIdOverviewRouteWithChildren
  '/venues/$id/rental': typeof RootLayoutVenuesIdRentalRouteWithChildren
  '/venues/$id/reports': typeof RootLayoutVenuesIdReportsRoute
  '/venues/$id/shows': typeof RootLayoutVenuesIdShowsRoute
  '/venues/$id/overview/$version': typeof RootLayoutVenuesIdOverviewVersionRoute
  '/venues/$id/rental/$version': typeof RootLayoutVenuesIdRentalVersionRoute
}
export interface FileRoutesByTo {
  '/dashboard': typeof RootLayoutDashboardRoute
  '/impressum': typeof RootLayoutImpressumRoute
  '/login': typeof RootLayoutLoginRoute
  '/mailinglists': typeof RootLayoutMailinglistsRoute
  '/profile': typeof RootLayoutProfileRoute
  '/reports': typeof RootLayoutReportsRoute
  '/system': typeof RootLayoutSystemRoute
  '/tasks': typeof RootLayoutTasksRoute
  '/': typeof RootLayoutIndexRoute
  '/artists/$id': typeof RootLayoutArtistsIdRouteWithChildren
  '/companies/$id': typeof RootLayoutCompaniesIdRouteWithChildren
  '/finance/deposits': typeof RootLayoutFinanceDepositsRoute
  '/finance/overview': typeof RootLayoutFinanceOverviewRoute
  '/persons/$id': typeof RootLayoutPersonsIdRouteWithChildren
  '/projects/festivals': typeof RootLayoutProjectsFestivalsRoute
  '/projects/sales': typeof RootLayoutProjectsSalesRoute
  '/projects/touring': typeof RootLayoutProjectsTouringRouteWithChildren
  '/venues/$id': typeof RootLayoutVenuesIdRouteWithChildren
  '/artists': typeof RootLayoutArtistsIndexRoute
  '/companies': typeof RootLayoutCompaniesIndexRoute
  '/documents': typeof RootLayoutDocumentsIndexRoute
  '/finance': typeof RootLayoutFinanceIndexRoute
  '/persons': typeof RootLayoutPersonsIndexRoute
  '/venues': typeof RootLayoutVenuesIndexRoute
  '/artists/$id/finance': typeof RootLayoutArtistsIdFinanceRoute
  '/artists/$id/general': typeof RootLayoutArtistsIdGeneralRoute
  '/artists/$id/shows': typeof RootLayoutArtistsIdShowsRoute
  '/companies/$id/artists': typeof RootLayoutCompaniesIdArtistsRoute
  '/companies/$id/employees': typeof RootLayoutCompaniesIdEmployeesRoute
  '/companies/$id/finance': typeof RootLayoutCompaniesIdFinanceRoute
  '/companies/$id/general': typeof RootLayoutCompaniesIdGeneralRoute
  '/companies/$id/holds': typeof RootLayoutCompaniesIdHoldsRoute
  '/companies/$id/shows': typeof RootLayoutCompaniesIdShowsRoute
  '/companies/$id/venues': typeof RootLayoutCompaniesIdVenuesRoute
  '/persons/$id/general': typeof RootLayoutPersonsIdGeneralRoute
  '/persons/$id/reports': typeof RootLayoutPersonsIdReportsRoute
  '/persons/$id/settlements': typeof RootLayoutPersonsIdSettlementsRoute
  '/persons/$id/tourrep': typeof RootLayoutPersonsIdTourrepRoute
  '/projects/touring/$id': typeof RootLayoutProjectsTouringIdRoute
  '/venues/$id/files': typeof RootLayoutVenuesIdFilesRoute
  '/venues/$id/general': typeof RootLayoutVenuesIdGeneralRoute
  '/venues/$id/holds': typeof RootLayoutVenuesIdHoldsRoute
  '/venues/$id/overview': typeof RootLayoutVenuesIdOverviewRouteWithChildren
  '/venues/$id/rental': typeof RootLayoutVenuesIdRentalRouteWithChildren
  '/venues/$id/reports': typeof RootLayoutVenuesIdReportsRoute
  '/venues/$id/shows': typeof RootLayoutVenuesIdShowsRoute
  '/venues/$id/overview/$version': typeof RootLayoutVenuesIdOverviewVersionRoute
  '/venues/$id/rental/$version': typeof RootLayoutVenuesIdRentalVersionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_rootLayout': typeof RootLayoutRouteWithChildren
  '/_rootLayout/artists': typeof RootLayoutArtistsRouteWithChildren
  '/_rootLayout/companies': typeof RootLayoutCompaniesRouteWithChildren
  '/_rootLayout/dashboard': typeof RootLayoutDashboardRoute
  '/_rootLayout/documents': typeof RootLayoutDocumentsRouteWithChildren
  '/_rootLayout/finance': typeof RootLayoutFinanceRouteWithChildren
  '/_rootLayout/impressum': typeof RootLayoutImpressumRoute
  '/_rootLayout/login': typeof RootLayoutLoginRoute
  '/_rootLayout/mailinglists': typeof RootLayoutMailinglistsRoute
  '/_rootLayout/persons': typeof RootLayoutPersonsRouteWithChildren
  '/_rootLayout/profile': typeof RootLayoutProfileRoute
  '/_rootLayout/reports': typeof RootLayoutReportsRoute
  '/_rootLayout/system': typeof RootLayoutSystemRoute
  '/_rootLayout/tasks': typeof RootLayoutTasksRoute
  '/_rootLayout/venues': typeof RootLayoutVenuesRouteWithChildren
  '/_rootLayout/': typeof RootLayoutIndexRoute
  '/_rootLayout/artists/$id': typeof RootLayoutArtistsIdRouteWithChildren
  '/_rootLayout/companies/$id': typeof RootLayoutCompaniesIdRouteWithChildren
  '/_rootLayout/finance/deposits': typeof RootLayoutFinanceDepositsRoute
  '/_rootLayout/finance/overview': typeof RootLayoutFinanceOverviewRoute
  '/_rootLayout/persons/$id': typeof RootLayoutPersonsIdRouteWithChildren
  '/_rootLayout/projects/festivals': typeof RootLayoutProjectsFestivalsRoute
  '/_rootLayout/projects/sales': typeof RootLayoutProjectsSalesRoute
  '/_rootLayout/projects/touring': typeof RootLayoutProjectsTouringRouteWithChildren
  '/_rootLayout/venues/$id': typeof RootLayoutVenuesIdRouteWithChildren
  '/_rootLayout/artists/': typeof RootLayoutArtistsIndexRoute
  '/_rootLayout/companies/': typeof RootLayoutCompaniesIndexRoute
  '/_rootLayout/documents/': typeof RootLayoutDocumentsIndexRoute
  '/_rootLayout/finance/': typeof RootLayoutFinanceIndexRoute
  '/_rootLayout/persons/': typeof RootLayoutPersonsIndexRoute
  '/_rootLayout/venues/': typeof RootLayoutVenuesIndexRoute
  '/_rootLayout/artists/$id/finance': typeof RootLayoutArtistsIdFinanceRoute
  '/_rootLayout/artists/$id/general': typeof RootLayoutArtistsIdGeneralRoute
  '/_rootLayout/artists/$id/shows': typeof RootLayoutArtistsIdShowsRoute
  '/_rootLayout/companies/$id/artists': typeof RootLayoutCompaniesIdArtistsRoute
  '/_rootLayout/companies/$id/employees': typeof RootLayoutCompaniesIdEmployeesRoute
  '/_rootLayout/companies/$id/finance': typeof RootLayoutCompaniesIdFinanceRoute
  '/_rootLayout/companies/$id/general': typeof RootLayoutCompaniesIdGeneralRoute
  '/_rootLayout/companies/$id/holds': typeof RootLayoutCompaniesIdHoldsRoute
  '/_rootLayout/companies/$id/shows': typeof RootLayoutCompaniesIdShowsRoute
  '/_rootLayout/companies/$id/venues': typeof RootLayoutCompaniesIdVenuesRoute
  '/_rootLayout/persons/$id/general': typeof RootLayoutPersonsIdGeneralRoute
  '/_rootLayout/persons/$id/reports': typeof RootLayoutPersonsIdReportsRoute
  '/_rootLayout/persons/$id/settlements': typeof RootLayoutPersonsIdSettlementsRoute
  '/_rootLayout/persons/$id/tourrep': typeof RootLayoutPersonsIdTourrepRoute
  '/_rootLayout/projects/touring/$id': typeof RootLayoutProjectsTouringIdRoute
  '/_rootLayout/venues/$id/files': typeof RootLayoutVenuesIdFilesRoute
  '/_rootLayout/venues/$id/general': typeof RootLayoutVenuesIdGeneralRoute
  '/_rootLayout/venues/$id/holds': typeof RootLayoutVenuesIdHoldsRoute
  '/_rootLayout/venues/$id/overview': typeof RootLayoutVenuesIdOverviewRouteWithChildren
  '/_rootLayout/venues/$id/rental': typeof RootLayoutVenuesIdRentalRouteWithChildren
  '/_rootLayout/venues/$id/reports': typeof RootLayoutVenuesIdReportsRoute
  '/_rootLayout/venues/$id/shows': typeof RootLayoutVenuesIdShowsRoute
  '/_rootLayout/venues/$id/overview/$version': typeof RootLayoutVenuesIdOverviewVersionRoute
  '/_rootLayout/venues/$id/rental/$version': typeof RootLayoutVenuesIdRentalVersionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/artists'
    | '/companies'
    | '/dashboard'
    | '/documents'
    | '/finance'
    | '/impressum'
    | '/login'
    | '/mailinglists'
    | '/persons'
    | '/profile'
    | '/reports'
    | '/system'
    | '/tasks'
    | '/venues'
    | '/artists/$id'
    | '/companies/$id'
    | '/finance/deposits'
    | '/finance/overview'
    | '/persons/$id'
    | '/projects/festivals'
    | '/projects/sales'
    | '/projects/touring'
    | '/venues/$id'
    | '/artists/'
    | '/companies/'
    | '/documents/'
    | '/finance/'
    | '/persons/'
    | '/venues/'
    | '/artists/$id/finance'
    | '/artists/$id/general'
    | '/artists/$id/shows'
    | '/companies/$id/artists'
    | '/companies/$id/employees'
    | '/companies/$id/finance'
    | '/companies/$id/general'
    | '/companies/$id/holds'
    | '/companies/$id/shows'
    | '/companies/$id/venues'
    | '/persons/$id/general'
    | '/persons/$id/reports'
    | '/persons/$id/settlements'
    | '/persons/$id/tourrep'
    | '/projects/touring/$id'
    | '/venues/$id/files'
    | '/venues/$id/general'
    | '/venues/$id/holds'
    | '/venues/$id/overview'
    | '/venues/$id/rental'
    | '/venues/$id/reports'
    | '/venues/$id/shows'
    | '/venues/$id/overview/$version'
    | '/venues/$id/rental/$version'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/dashboard'
    | '/impressum'
    | '/login'
    | '/mailinglists'
    | '/profile'
    | '/reports'
    | '/system'
    | '/tasks'
    | '/'
    | '/artists/$id'
    | '/companies/$id'
    | '/finance/deposits'
    | '/finance/overview'
    | '/persons/$id'
    | '/projects/festivals'
    | '/projects/sales'
    | '/projects/touring'
    | '/venues/$id'
    | '/artists'
    | '/companies'
    | '/documents'
    | '/finance'
    | '/persons'
    | '/venues'
    | '/artists/$id/finance'
    | '/artists/$id/general'
    | '/artists/$id/shows'
    | '/companies/$id/artists'
    | '/companies/$id/employees'
    | '/companies/$id/finance'
    | '/companies/$id/general'
    | '/companies/$id/holds'
    | '/companies/$id/shows'
    | '/companies/$id/venues'
    | '/persons/$id/general'
    | '/persons/$id/reports'
    | '/persons/$id/settlements'
    | '/persons/$id/tourrep'
    | '/projects/touring/$id'
    | '/venues/$id/files'
    | '/venues/$id/general'
    | '/venues/$id/holds'
    | '/venues/$id/overview'
    | '/venues/$id/rental'
    | '/venues/$id/reports'
    | '/venues/$id/shows'
    | '/venues/$id/overview/$version'
    | '/venues/$id/rental/$version'
  id:
    | '__root__'
    | '/_rootLayout'
    | '/_rootLayout/artists'
    | '/_rootLayout/companies'
    | '/_rootLayout/dashboard'
    | '/_rootLayout/documents'
    | '/_rootLayout/finance'
    | '/_rootLayout/impressum'
    | '/_rootLayout/login'
    | '/_rootLayout/mailinglists'
    | '/_rootLayout/persons'
    | '/_rootLayout/profile'
    | '/_rootLayout/reports'
    | '/_rootLayout/system'
    | '/_rootLayout/tasks'
    | '/_rootLayout/venues'
    | '/_rootLayout/'
    | '/_rootLayout/artists/$id'
    | '/_rootLayout/companies/$id'
    | '/_rootLayout/finance/deposits'
    | '/_rootLayout/finance/overview'
    | '/_rootLayout/persons/$id'
    | '/_rootLayout/projects/festivals'
    | '/_rootLayout/projects/sales'
    | '/_rootLayout/projects/touring'
    | '/_rootLayout/venues/$id'
    | '/_rootLayout/artists/'
    | '/_rootLayout/companies/'
    | '/_rootLayout/documents/'
    | '/_rootLayout/finance/'
    | '/_rootLayout/persons/'
    | '/_rootLayout/venues/'
    | '/_rootLayout/artists/$id/finance'
    | '/_rootLayout/artists/$id/general'
    | '/_rootLayout/artists/$id/shows'
    | '/_rootLayout/companies/$id/artists'
    | '/_rootLayout/companies/$id/employees'
    | '/_rootLayout/companies/$id/finance'
    | '/_rootLayout/companies/$id/general'
    | '/_rootLayout/companies/$id/holds'
    | '/_rootLayout/companies/$id/shows'
    | '/_rootLayout/companies/$id/venues'
    | '/_rootLayout/persons/$id/general'
    | '/_rootLayout/persons/$id/reports'
    | '/_rootLayout/persons/$id/settlements'
    | '/_rootLayout/persons/$id/tourrep'
    | '/_rootLayout/projects/touring/$id'
    | '/_rootLayout/venues/$id/files'
    | '/_rootLayout/venues/$id/general'
    | '/_rootLayout/venues/$id/holds'
    | '/_rootLayout/venues/$id/overview'
    | '/_rootLayout/venues/$id/rental'
    | '/_rootLayout/venues/$id/reports'
    | '/_rootLayout/venues/$id/shows'
    | '/_rootLayout/venues/$id/overview/$version'
    | '/_rootLayout/venues/$id/rental/$version'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  RootLayoutRoute: typeof RootLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_rootLayout': {
      id: '/_rootLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof RootLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_rootLayout/': {
      id: '/_rootLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof RootLayoutIndexRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/venues': {
      id: '/_rootLayout/venues'
      path: '/venues'
      fullPath: '/venues'
      preLoaderRoute: typeof RootLayoutVenuesRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/tasks': {
      id: '/_rootLayout/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof RootLayoutTasksRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/system': {
      id: '/_rootLayout/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof RootLayoutSystemRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/reports': {
      id: '/_rootLayout/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof RootLayoutReportsRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/profile': {
      id: '/_rootLayout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof RootLayoutProfileRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/persons': {
      id: '/_rootLayout/persons'
      path: '/persons'
      fullPath: '/persons'
      preLoaderRoute: typeof RootLayoutPersonsRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/mailinglists': {
      id: '/_rootLayout/mailinglists'
      path: '/mailinglists'
      fullPath: '/mailinglists'
      preLoaderRoute: typeof RootLayoutMailinglistsRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/login': {
      id: '/_rootLayout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof RootLayoutLoginRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/impressum': {
      id: '/_rootLayout/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof RootLayoutImpressumRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/finance': {
      id: '/_rootLayout/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof RootLayoutFinanceRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/documents': {
      id: '/_rootLayout/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof RootLayoutDocumentsRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/dashboard': {
      id: '/_rootLayout/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof RootLayoutDashboardRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/companies': {
      id: '/_rootLayout/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof RootLayoutCompaniesRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/artists': {
      id: '/_rootLayout/artists'
      path: '/artists'
      fullPath: '/artists'
      preLoaderRoute: typeof RootLayoutArtistsRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/venues/': {
      id: '/_rootLayout/venues/'
      path: '/'
      fullPath: '/venues/'
      preLoaderRoute: typeof RootLayoutVenuesIndexRouteImport
      parentRoute: typeof RootLayoutVenuesRoute
    }
    '/_rootLayout/persons/': {
      id: '/_rootLayout/persons/'
      path: '/'
      fullPath: '/persons/'
      preLoaderRoute: typeof RootLayoutPersonsIndexRouteImport
      parentRoute: typeof RootLayoutPersonsRoute
    }
    '/_rootLayout/finance/': {
      id: '/_rootLayout/finance/'
      path: '/'
      fullPath: '/finance/'
      preLoaderRoute: typeof RootLayoutFinanceIndexRouteImport
      parentRoute: typeof RootLayoutFinanceRoute
    }
    '/_rootLayout/documents/': {
      id: '/_rootLayout/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof RootLayoutDocumentsIndexRouteImport
      parentRoute: typeof RootLayoutDocumentsRoute
    }
    '/_rootLayout/companies/': {
      id: '/_rootLayout/companies/'
      path: '/'
      fullPath: '/companies/'
      preLoaderRoute: typeof RootLayoutCompaniesIndexRouteImport
      parentRoute: typeof RootLayoutCompaniesRoute
    }
    '/_rootLayout/artists/': {
      id: '/_rootLayout/artists/'
      path: '/'
      fullPath: '/artists/'
      preLoaderRoute: typeof RootLayoutArtistsIndexRouteImport
      parentRoute: typeof RootLayoutArtistsRoute
    }
    '/_rootLayout/venues/$id': {
      id: '/_rootLayout/venues/$id'
      path: '/$id'
      fullPath: '/venues/$id'
      preLoaderRoute: typeof RootLayoutVenuesIdRouteImport
      parentRoute: typeof RootLayoutVenuesRoute
    }
    '/_rootLayout/projects/touring': {
      id: '/_rootLayout/projects/touring'
      path: '/projects/touring'
      fullPath: '/projects/touring'
      preLoaderRoute: typeof RootLayoutProjectsTouringRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/projects/sales': {
      id: '/_rootLayout/projects/sales'
      path: '/projects/sales'
      fullPath: '/projects/sales'
      preLoaderRoute: typeof RootLayoutProjectsSalesRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/projects/festivals': {
      id: '/_rootLayout/projects/festivals'
      path: '/projects/festivals'
      fullPath: '/projects/festivals'
      preLoaderRoute: typeof RootLayoutProjectsFestivalsRouteImport
      parentRoute: typeof RootLayoutRoute
    }
    '/_rootLayout/persons/$id': {
      id: '/_rootLayout/persons/$id'
      path: '/$id'
      fullPath: '/persons/$id'
      preLoaderRoute: typeof RootLayoutPersonsIdRouteImport
      parentRoute: typeof RootLayoutPersonsRoute
    }
    '/_rootLayout/finance/overview': {
      id: '/_rootLayout/finance/overview'
      path: '/overview'
      fullPath: '/finance/overview'
      preLoaderRoute: typeof RootLayoutFinanceOverviewRouteImport
      parentRoute: typeof RootLayoutFinanceRoute
    }
    '/_rootLayout/finance/deposits': {
      id: '/_rootLayout/finance/deposits'
      path: '/deposits'
      fullPath: '/finance/deposits'
      preLoaderRoute: typeof RootLayoutFinanceDepositsRouteImport
      parentRoute: typeof RootLayoutFinanceRoute
    }
    '/_rootLayout/companies/$id': {
      id: '/_rootLayout/companies/$id'
      path: '/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof RootLayoutCompaniesIdRouteImport
      parentRoute: typeof RootLayoutCompaniesRoute
    }
    '/_rootLayout/artists/$id': {
      id: '/_rootLayout/artists/$id'
      path: '/$id'
      fullPath: '/artists/$id'
      preLoaderRoute: typeof RootLayoutArtistsIdRouteImport
      parentRoute: typeof RootLayoutArtistsRoute
    }
    '/_rootLayout/venues/$id/shows': {
      id: '/_rootLayout/venues/$id/shows'
      path: '/shows'
      fullPath: '/venues/$id/shows'
      preLoaderRoute: typeof RootLayoutVenuesIdShowsRouteImport
      parentRoute: typeof RootLayoutVenuesIdRoute
    }
    '/_rootLayout/venues/$id/reports': {
      id: '/_rootLayout/venues/$id/reports'
      path: '/reports'
      fullPath: '/venues/$id/reports'
      preLoaderRoute: typeof RootLayoutVenuesIdReportsRouteImport
      parentRoute: typeof RootLayoutVenuesIdRoute
    }
    '/_rootLayout/venues/$id/rental': {
      id: '/_rootLayout/venues/$id/rental'
      path: '/rental'
      fullPath: '/venues/$id/rental'
      preLoaderRoute: typeof RootLayoutVenuesIdRentalRouteImport
      parentRoute: typeof RootLayoutVenuesIdRoute
    }
    '/_rootLayout/venues/$id/overview': {
      id: '/_rootLayout/venues/$id/overview'
      path: '/overview'
      fullPath: '/venues/$id/overview'
      preLoaderRoute: typeof RootLayoutVenuesIdOverviewRouteImport
      parentRoute: typeof RootLayoutVenuesIdRoute
    }
    '/_rootLayout/venues/$id/holds': {
      id: '/_rootLayout/venues/$id/holds'
      path: '/holds'
      fullPath: '/venues/$id/holds'
      preLoaderRoute: typeof RootLayoutVenuesIdHoldsRouteImport
      parentRoute: typeof RootLayoutVenuesIdRoute
    }
    '/_rootLayout/venues/$id/general': {
      id: '/_rootLayout/venues/$id/general'
      path: '/general'
      fullPath: '/venues/$id/general'
      preLoaderRoute: typeof RootLayoutVenuesIdGeneralRouteImport
      parentRoute: typeof RootLayoutVenuesIdRoute
    }
    '/_rootLayout/venues/$id/files': {
      id: '/_rootLayout/venues/$id/files'
      path: '/files'
      fullPath: '/venues/$id/files'
      preLoaderRoute: typeof RootLayoutVenuesIdFilesRouteImport
      parentRoute: typeof RootLayoutVenuesIdRoute
    }
    '/_rootLayout/projects/touring/$id': {
      id: '/_rootLayout/projects/touring/$id'
      path: '/$id'
      fullPath: '/projects/touring/$id'
      preLoaderRoute: typeof RootLayoutProjectsTouringIdRouteImport
      parentRoute: typeof RootLayoutProjectsTouringRoute
    }
    '/_rootLayout/persons/$id/tourrep': {
      id: '/_rootLayout/persons/$id/tourrep'
      path: '/tourrep'
      fullPath: '/persons/$id/tourrep'
      preLoaderRoute: typeof RootLayoutPersonsIdTourrepRouteImport
      parentRoute: typeof RootLayoutPersonsIdRoute
    }
    '/_rootLayout/persons/$id/settlements': {
      id: '/_rootLayout/persons/$id/settlements'
      path: '/settlements'
      fullPath: '/persons/$id/settlements'
      preLoaderRoute: typeof RootLayoutPersonsIdSettlementsRouteImport
      parentRoute: typeof RootLayoutPersonsIdRoute
    }
    '/_rootLayout/persons/$id/reports': {
      id: '/_rootLayout/persons/$id/reports'
      path: '/reports'
      fullPath: '/persons/$id/reports'
      preLoaderRoute: typeof RootLayoutPersonsIdReportsRouteImport
      parentRoute: typeof RootLayoutPersonsIdRoute
    }
    '/_rootLayout/persons/$id/general': {
      id: '/_rootLayout/persons/$id/general'
      path: '/general'
      fullPath: '/persons/$id/general'
      preLoaderRoute: typeof RootLayoutPersonsIdGeneralRouteImport
      parentRoute: typeof RootLayoutPersonsIdRoute
    }
    '/_rootLayout/companies/$id/venues': {
      id: '/_rootLayout/companies/$id/venues'
      path: '/venues'
      fullPath: '/companies/$id/venues'
      preLoaderRoute: typeof RootLayoutCompaniesIdVenuesRouteImport
      parentRoute: typeof RootLayoutCompaniesIdRoute
    }
    '/_rootLayout/companies/$id/shows': {
      id: '/_rootLayout/companies/$id/shows'
      path: '/shows'
      fullPath: '/companies/$id/shows'
      preLoaderRoute: typeof RootLayoutCompaniesIdShowsRouteImport
      parentRoute: typeof RootLayoutCompaniesIdRoute
    }
    '/_rootLayout/companies/$id/holds': {
      id: '/_rootLayout/companies/$id/holds'
      path: '/holds'
      fullPath: '/companies/$id/holds'
      preLoaderRoute: typeof RootLayoutCompaniesIdHoldsRouteImport
      parentRoute: typeof RootLayoutCompaniesIdRoute
    }
    '/_rootLayout/companies/$id/general': {
      id: '/_rootLayout/companies/$id/general'
      path: '/general'
      fullPath: '/companies/$id/general'
      preLoaderRoute: typeof RootLayoutCompaniesIdGeneralRouteImport
      parentRoute: typeof RootLayoutCompaniesIdRoute
    }
    '/_rootLayout/companies/$id/finance': {
      id: '/_rootLayout/companies/$id/finance'
      path: '/finance'
      fullPath: '/companies/$id/finance'
      preLoaderRoute: typeof RootLayoutCompaniesIdFinanceRouteImport
      parentRoute: typeof RootLayoutCompaniesIdRoute
    }
    '/_rootLayout/companies/$id/employees': {
      id: '/_rootLayout/companies/$id/employees'
      path: '/employees'
      fullPath: '/companies/$id/employees'
      preLoaderRoute: typeof RootLayoutCompaniesIdEmployeesRouteImport
      parentRoute: typeof RootLayoutCompaniesIdRoute
    }
    '/_rootLayout/companies/$id/artists': {
      id: '/_rootLayout/companies/$id/artists'
      path: '/artists'
      fullPath: '/companies/$id/artists'
      preLoaderRoute: typeof RootLayoutCompaniesIdArtistsRouteImport
      parentRoute: typeof RootLayoutCompaniesIdRoute
    }
    '/_rootLayout/artists/$id/shows': {
      id: '/_rootLayout/artists/$id/shows'
      path: '/shows'
      fullPath: '/artists/$id/shows'
      preLoaderRoute: typeof RootLayoutArtistsIdShowsRouteImport
      parentRoute: typeof RootLayoutArtistsIdRoute
    }
    '/_rootLayout/artists/$id/general': {
      id: '/_rootLayout/artists/$id/general'
      path: '/general'
      fullPath: '/artists/$id/general'
      preLoaderRoute: typeof RootLayoutArtistsIdGeneralRouteImport
      parentRoute: typeof RootLayoutArtistsIdRoute
    }
    '/_rootLayout/artists/$id/finance': {
      id: '/_rootLayout/artists/$id/finance'
      path: '/finance'
      fullPath: '/artists/$id/finance'
      preLoaderRoute: typeof RootLayoutArtistsIdFinanceRouteImport
      parentRoute: typeof RootLayoutArtistsIdRoute
    }
    '/_rootLayout/venues/$id/rental/$version': {
      id: '/_rootLayout/venues/$id/rental/$version'
      path: '/$version'
      fullPath: '/venues/$id/rental/$version'
      preLoaderRoute: typeof RootLayoutVenuesIdRentalVersionRouteImport
      parentRoute: typeof RootLayoutVenuesIdRentalRoute
    }
    '/_rootLayout/venues/$id/overview/$version': {
      id: '/_rootLayout/venues/$id/overview/$version'
      path: '/$version'
      fullPath: '/venues/$id/overview/$version'
      preLoaderRoute: typeof RootLayoutVenuesIdOverviewVersionRouteImport
      parentRoute: typeof RootLayoutVenuesIdOverviewRoute
    }
  }
}

interface RootLayoutArtistsIdRouteChildren {
  RootLayoutArtistsIdFinanceRoute: typeof RootLayoutArtistsIdFinanceRoute
  RootLayoutArtistsIdGeneralRoute: typeof RootLayoutArtistsIdGeneralRoute
  RootLayoutArtistsIdShowsRoute: typeof RootLayoutArtistsIdShowsRoute
}

const RootLayoutArtistsIdRouteChildren: RootLayoutArtistsIdRouteChildren = {
  RootLayoutArtistsIdFinanceRoute: RootLayoutArtistsIdFinanceRoute,
  RootLayoutArtistsIdGeneralRoute: RootLayoutArtistsIdGeneralRoute,
  RootLayoutArtistsIdShowsRoute: RootLayoutArtistsIdShowsRoute,
}

const RootLayoutArtistsIdRouteWithChildren =
  RootLayoutArtistsIdRoute._addFileChildren(RootLayoutArtistsIdRouteChildren)

interface RootLayoutArtistsRouteChildren {
  RootLayoutArtistsIdRoute: typeof RootLayoutArtistsIdRouteWithChildren
  RootLayoutArtistsIndexRoute: typeof RootLayoutArtistsIndexRoute
}

const RootLayoutArtistsRouteChildren: RootLayoutArtistsRouteChildren = {
  RootLayoutArtistsIdRoute: RootLayoutArtistsIdRouteWithChildren,
  RootLayoutArtistsIndexRoute: RootLayoutArtistsIndexRoute,
}

const RootLayoutArtistsRouteWithChildren =
  RootLayoutArtistsRoute._addFileChildren(RootLayoutArtistsRouteChildren)

interface RootLayoutCompaniesIdRouteChildren {
  RootLayoutCompaniesIdArtistsRoute: typeof RootLayoutCompaniesIdArtistsRoute
  RootLayoutCompaniesIdEmployeesRoute: typeof RootLayoutCompaniesIdEmployeesRoute
  RootLayoutCompaniesIdFinanceRoute: typeof RootLayoutCompaniesIdFinanceRoute
  RootLayoutCompaniesIdGeneralRoute: typeof RootLayoutCompaniesIdGeneralRoute
  RootLayoutCompaniesIdHoldsRoute: typeof RootLayoutCompaniesIdHoldsRoute
  RootLayoutCompaniesIdShowsRoute: typeof RootLayoutCompaniesIdShowsRoute
  RootLayoutCompaniesIdVenuesRoute: typeof RootLayoutCompaniesIdVenuesRoute
}

const RootLayoutCompaniesIdRouteChildren: RootLayoutCompaniesIdRouteChildren = {
  RootLayoutCompaniesIdArtistsRoute: RootLayoutCompaniesIdArtistsRoute,
  RootLayoutCompaniesIdEmployeesRoute: RootLayoutCompaniesIdEmployeesRoute,
  RootLayoutCompaniesIdFinanceRoute: RootLayoutCompaniesIdFinanceRoute,
  RootLayoutCompaniesIdGeneralRoute: RootLayoutCompaniesIdGeneralRoute,
  RootLayoutCompaniesIdHoldsRoute: RootLayoutCompaniesIdHoldsRoute,
  RootLayoutCompaniesIdShowsRoute: RootLayoutCompaniesIdShowsRoute,
  RootLayoutCompaniesIdVenuesRoute: RootLayoutCompaniesIdVenuesRoute,
}

const RootLayoutCompaniesIdRouteWithChildren =
  RootLayoutCompaniesIdRoute._addFileChildren(
    RootLayoutCompaniesIdRouteChildren,
  )

interface RootLayoutCompaniesRouteChildren {
  RootLayoutCompaniesIdRoute: typeof RootLayoutCompaniesIdRouteWithChildren
  RootLayoutCompaniesIndexRoute: typeof RootLayoutCompaniesIndexRoute
}

const RootLayoutCompaniesRouteChildren: RootLayoutCompaniesRouteChildren = {
  RootLayoutCompaniesIdRoute: RootLayoutCompaniesIdRouteWithChildren,
  RootLayoutCompaniesIndexRoute: RootLayoutCompaniesIndexRoute,
}

const RootLayoutCompaniesRouteWithChildren =
  RootLayoutCompaniesRoute._addFileChildren(RootLayoutCompaniesRouteChildren)

interface RootLayoutDocumentsRouteChildren {
  RootLayoutDocumentsIndexRoute: typeof RootLayoutDocumentsIndexRoute
}

const RootLayoutDocumentsRouteChildren: RootLayoutDocumentsRouteChildren = {
  RootLayoutDocumentsIndexRoute: RootLayoutDocumentsIndexRoute,
}

const RootLayoutDocumentsRouteWithChildren =
  RootLayoutDocumentsRoute._addFileChildren(RootLayoutDocumentsRouteChildren)

interface RootLayoutFinanceRouteChildren {
  RootLayoutFinanceDepositsRoute: typeof RootLayoutFinanceDepositsRoute
  RootLayoutFinanceOverviewRoute: typeof RootLayoutFinanceOverviewRoute
  RootLayoutFinanceIndexRoute: typeof RootLayoutFinanceIndexRoute
}

const RootLayoutFinanceRouteChildren: RootLayoutFinanceRouteChildren = {
  RootLayoutFinanceDepositsRoute: RootLayoutFinanceDepositsRoute,
  RootLayoutFinanceOverviewRoute: RootLayoutFinanceOverviewRoute,
  RootLayoutFinanceIndexRoute: RootLayoutFinanceIndexRoute,
}

const RootLayoutFinanceRouteWithChildren =
  RootLayoutFinanceRoute._addFileChildren(RootLayoutFinanceRouteChildren)

interface RootLayoutPersonsIdRouteChildren {
  RootLayoutPersonsIdGeneralRoute: typeof RootLayoutPersonsIdGeneralRoute
  RootLayoutPersonsIdReportsRoute: typeof RootLayoutPersonsIdReportsRoute
  RootLayoutPersonsIdSettlementsRoute: typeof RootLayoutPersonsIdSettlementsRoute
  RootLayoutPersonsIdTourrepRoute: typeof RootLayoutPersonsIdTourrepRoute
}

const RootLayoutPersonsIdRouteChildren: RootLayoutPersonsIdRouteChildren = {
  RootLayoutPersonsIdGeneralRoute: RootLayoutPersonsIdGeneralRoute,
  RootLayoutPersonsIdReportsRoute: RootLayoutPersonsIdReportsRoute,
  RootLayoutPersonsIdSettlementsRoute: RootLayoutPersonsIdSettlementsRoute,
  RootLayoutPersonsIdTourrepRoute: RootLayoutPersonsIdTourrepRoute,
}

const RootLayoutPersonsIdRouteWithChildren =
  RootLayoutPersonsIdRoute._addFileChildren(RootLayoutPersonsIdRouteChildren)

interface RootLayoutPersonsRouteChildren {
  RootLayoutPersonsIdRoute: typeof RootLayoutPersonsIdRouteWithChildren
  RootLayoutPersonsIndexRoute: typeof RootLayoutPersonsIndexRoute
}

const RootLayoutPersonsRouteChildren: RootLayoutPersonsRouteChildren = {
  RootLayoutPersonsIdRoute: RootLayoutPersonsIdRouteWithChildren,
  RootLayoutPersonsIndexRoute: RootLayoutPersonsIndexRoute,
}

const RootLayoutPersonsRouteWithChildren =
  RootLayoutPersonsRoute._addFileChildren(RootLayoutPersonsRouteChildren)

interface RootLayoutVenuesIdOverviewRouteChildren {
  RootLayoutVenuesIdOverviewVersionRoute: typeof RootLayoutVenuesIdOverviewVersionRoute
}

const RootLayoutVenuesIdOverviewRouteChildren: RootLayoutVenuesIdOverviewRouteChildren =
  {
    RootLayoutVenuesIdOverviewVersionRoute:
      RootLayoutVenuesIdOverviewVersionRoute,
  }

const RootLayoutVenuesIdOverviewRouteWithChildren =
  RootLayoutVenuesIdOverviewRoute._addFileChildren(
    RootLayoutVenuesIdOverviewRouteChildren,
  )

interface RootLayoutVenuesIdRentalRouteChildren {
  RootLayoutVenuesIdRentalVersionRoute: typeof RootLayoutVenuesIdRentalVersionRoute
}

const RootLayoutVenuesIdRentalRouteChildren: RootLayoutVenuesIdRentalRouteChildren =
  {
    RootLayoutVenuesIdRentalVersionRoute: RootLayoutVenuesIdRentalVersionRoute,
  }

const RootLayoutVenuesIdRentalRouteWithChildren =
  RootLayoutVenuesIdRentalRoute._addFileChildren(
    RootLayoutVenuesIdRentalRouteChildren,
  )

interface RootLayoutVenuesIdRouteChildren {
  RootLayoutVenuesIdFilesRoute: typeof RootLayoutVenuesIdFilesRoute
  RootLayoutVenuesIdGeneralRoute: typeof RootLayoutVenuesIdGeneralRoute
  RootLayoutVenuesIdHoldsRoute: typeof RootLayoutVenuesIdHoldsRoute
  RootLayoutVenuesIdOverviewRoute: typeof RootLayoutVenuesIdOverviewRouteWithChildren
  RootLayoutVenuesIdRentalRoute: typeof RootLayoutVenuesIdRentalRouteWithChildren
  RootLayoutVenuesIdReportsRoute: typeof RootLayoutVenuesIdReportsRoute
  RootLayoutVenuesIdShowsRoute: typeof RootLayoutVenuesIdShowsRoute
}

const RootLayoutVenuesIdRouteChildren: RootLayoutVenuesIdRouteChildren = {
  RootLayoutVenuesIdFilesRoute: RootLayoutVenuesIdFilesRoute,
  RootLayoutVenuesIdGeneralRoute: RootLayoutVenuesIdGeneralRoute,
  RootLayoutVenuesIdHoldsRoute: RootLayoutVenuesIdHoldsRoute,
  RootLayoutVenuesIdOverviewRoute: RootLayoutVenuesIdOverviewRouteWithChildren,
  RootLayoutVenuesIdRentalRoute: RootLayoutVenuesIdRentalRouteWithChildren,
  RootLayoutVenuesIdReportsRoute: RootLayoutVenuesIdReportsRoute,
  RootLayoutVenuesIdShowsRoute: RootLayoutVenuesIdShowsRoute,
}

const RootLayoutVenuesIdRouteWithChildren =
  RootLayoutVenuesIdRoute._addFileChildren(RootLayoutVenuesIdRouteChildren)

interface RootLayoutVenuesRouteChildren {
  RootLayoutVenuesIdRoute: typeof RootLayoutVenuesIdRouteWithChildren
  RootLayoutVenuesIndexRoute: typeof RootLayoutVenuesIndexRoute
}

const RootLayoutVenuesRouteChildren: RootLayoutVenuesRouteChildren = {
  RootLayoutVenuesIdRoute: RootLayoutVenuesIdRouteWithChildren,
  RootLayoutVenuesIndexRoute: RootLayoutVenuesIndexRoute,
}

const RootLayoutVenuesRouteWithChildren =
  RootLayoutVenuesRoute._addFileChildren(RootLayoutVenuesRouteChildren)

interface RootLayoutProjectsTouringRouteChildren {
  RootLayoutProjectsTouringIdRoute: typeof RootLayoutProjectsTouringIdRoute
}

const RootLayoutProjectsTouringRouteChildren: RootLayoutProjectsTouringRouteChildren =
  {
    RootLayoutProjectsTouringIdRoute: RootLayoutProjectsTouringIdRoute,
  }

const RootLayoutProjectsTouringRouteWithChildren =
  RootLayoutProjectsTouringRoute._addFileChildren(
    RootLayoutProjectsTouringRouteChildren,
  )

interface RootLayoutRouteChildren {
  RootLayoutArtistsRoute: typeof RootLayoutArtistsRouteWithChildren
  RootLayoutCompaniesRoute: typeof RootLayoutCompaniesRouteWithChildren
  RootLayoutDashboardRoute: typeof RootLayoutDashboardRoute
  RootLayoutDocumentsRoute: typeof RootLayoutDocumentsRouteWithChildren
  RootLayoutFinanceRoute: typeof RootLayoutFinanceRouteWithChildren
  RootLayoutImpressumRoute: typeof RootLayoutImpressumRoute
  RootLayoutLoginRoute: typeof RootLayoutLoginRoute
  RootLayoutMailinglistsRoute: typeof RootLayoutMailinglistsRoute
  RootLayoutPersonsRoute: typeof RootLayoutPersonsRouteWithChildren
  RootLayoutProfileRoute: typeof RootLayoutProfileRoute
  RootLayoutReportsRoute: typeof RootLayoutReportsRoute
  RootLayoutSystemRoute: typeof RootLayoutSystemRoute
  RootLayoutTasksRoute: typeof RootLayoutTasksRoute
  RootLayoutVenuesRoute: typeof RootLayoutVenuesRouteWithChildren
  RootLayoutIndexRoute: typeof RootLayoutIndexRoute
  RootLayoutProjectsFestivalsRoute: typeof RootLayoutProjectsFestivalsRoute
  RootLayoutProjectsSalesRoute: typeof RootLayoutProjectsSalesRoute
  RootLayoutProjectsTouringRoute: typeof RootLayoutProjectsTouringRouteWithChildren
}

const RootLayoutRouteChildren: RootLayoutRouteChildren = {
  RootLayoutArtistsRoute: RootLayoutArtistsRouteWithChildren,
  RootLayoutCompaniesRoute: RootLayoutCompaniesRouteWithChildren,
  RootLayoutDashboardRoute: RootLayoutDashboardRoute,
  RootLayoutDocumentsRoute: RootLayoutDocumentsRouteWithChildren,
  RootLayoutFinanceRoute: RootLayoutFinanceRouteWithChildren,
  RootLayoutImpressumRoute: RootLayoutImpressumRoute,
  RootLayoutLoginRoute: RootLayoutLoginRoute,
  RootLayoutMailinglistsRoute: RootLayoutMailinglistsRoute,
  RootLayoutPersonsRoute: RootLayoutPersonsRouteWithChildren,
  RootLayoutProfileRoute: RootLayoutProfileRoute,
  RootLayoutReportsRoute: RootLayoutReportsRoute,
  RootLayoutSystemRoute: RootLayoutSystemRoute,
  RootLayoutTasksRoute: RootLayoutTasksRoute,
  RootLayoutVenuesRoute: RootLayoutVenuesRouteWithChildren,
  RootLayoutIndexRoute: RootLayoutIndexRoute,
  RootLayoutProjectsFestivalsRoute: RootLayoutProjectsFestivalsRoute,
  RootLayoutProjectsSalesRoute: RootLayoutProjectsSalesRoute,
  RootLayoutProjectsTouringRoute: RootLayoutProjectsTouringRouteWithChildren,
}

const RootLayoutRouteWithChildren = RootLayoutRoute._addFileChildren(
  RootLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  RootLayoutRoute: RootLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
